// extracted by mini-css-extract-plugin
export var inner = "LoadingSpinner-module--inner--af22c";
export var spin = "LoadingSpinner-module--spin--53f48";
export var spinner = "LoadingSpinner-module--spinner--c5392";